/* HeyBear · Snack moments: native sticky horizontal scroll + card hover tilt. */
HB.section('moments', function (root) {
  HB.reveal(root);
  var off = [], frame = 0, distance = 0, resizeObserver = null, destroyed = false;
  var pin = root.querySelector('#momentsPin');
  var track = root.querySelector('#htrack');
  var cards = [].slice.call(root.querySelectorAll('.card'));
  var desktop = matchMedia('(min-width: 900px) and (prefers-reduced-motion: no-preference)');
  var on = function (target, event, fn, options) {
    target.addEventListener(event, fn, options);
    off.push(function () { target.removeEventListener(event, fn, options); });
  };
  if (HB.fine && !HB.reduce) [].forEach.call(root.querySelectorAll('.card'), function (c) {
    var mv = function (e) { var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; c.style.translate = '0 -6px'; var a = c.querySelector('.art'); if (a) a.style.transform = 'translate(' + (x * 12) + 'px,' + (y * 8) + 'px)'; };
    var lv = function () { c.style.translate = ''; var a = c.querySelector('.art'); if (a) a.style.transform = ''; };
    on(c, 'pointermove', mv); on(c, 'pointerleave', lv);
  });

  function draw() {
    frame = 0;
    if (destroyed || !desktop.matches || !distance) return;
    var progress = Math.max(0, Math.min(1, -root.getBoundingClientRect().top / distance));
    var x = -distance * progress;
    track.style.transform = 'translate3d(' + x + 'px,0,0)';
    cards.forEach(function (card, i) {
      var centre = card.offsetLeft + x + card.offsetWidth / 2;
      var across = Math.max(0, Math.min(1, (innerWidth - centre + card.offsetWidth) / (innerWidth + card.offsetWidth)));
      var ry = -16 + across * 24;
      var rz = (i % 2 ? 2 : -2) + across * (i % 2 ? -3.5 : 3.5);
      card.style.transform = 'rotateY(' + ry + 'deg) rotateZ(' + rz + 'deg)';
    });
  }

  function requestDraw() { if (!frame) frame = requestAnimationFrame(draw); }
  function measure() {
    if (destroyed) return;
    var active = desktop.matches && pin && track;
    root.classList.toggle('is-horizontal', !!active);
    if (!active) {
      distance = 0;
      root.style.removeProperty('--moments-distance');
      if (track) track.style.transform = '';
      cards.forEach(function (card) { card.style.transform = ''; });
      return;
    }
    distance = Math.max(0, track.scrollWidth - document.documentElement.clientWidth);
    root.style.setProperty('--moments-distance', distance + 'px');
    requestDraw();
  }

  on(window, 'scroll', requestDraw, { passive: true });
  on(window, 'resize', measure, { passive: true });
  if (desktop.addEventListener) on(desktop, 'change', measure);
  else if (desktop.addListener) { desktop.addListener(measure); off.push(function () { desktop.removeListener(measure); }); }
  if ('ResizeObserver' in window && track) {
    resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(track);
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure).catch(function () {});
  on(window, 'load', measure);
  measure();

  return function () {
    destroyed = true;
    off.forEach(function (f) { f(); });
    if (frame) cancelAnimationFrame(frame);
    if (resizeObserver) resizeObserver.disconnect();
    root.classList.remove('is-horizontal');
    root.style.removeProperty('--moments-distance');
    if (track) track.style.transform = '';
    cards.forEach(function (card) { card.style.transform = ''; });
  };
});
